import React from "react";
import TextField from "@mui/material/TextField";

const PhoneWidget = (props) => {
  const { id, value, required, disabled, readonly, autofocus, onChange, onBlur, onFocus, options, schema, label } =
    props;

  const handleChange = (event) => {
    // Format phone number as user types
    let input = event.target.value.replace(/\D/g, "");
    let formatted = "";

    if (input.length > 0) {
      formatted = "(" + input.substring(0, 3);
      if (input.length > 3) {
        formatted += ") " + input.substring(3, 6);
      }
      if (input.length > 6) {
        formatted += "-" + input.substring(6, 10);
      }
    }

    onChange(formatted || undefined);
  };

  return (
    <TextField
      id={id}
      label={label || schema.title}
      value={value || ""}
      required={required}
      disabled={disabled}
      readOnly={readonly}
      autoFocus={autofocus}
      onChange={handleChange}
      onBlur={onBlur && ((event) => onBlur(id, event.target.value))}
      onFocus={onFocus && ((event) => onFocus(id, event.target.value))}
      placeholder={options.placeholder || "(555) 555-5555"}
      fullWidth
      variant="outlined"
      size="small"
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        maxLength: 14,
      }}
    />
  );
};

export default PhoneWidget;
